(() => {
  const money = (cents) => {
    const fmt = (window.aureaMoneyFormat || '{{amount_with_comma_separator}} zł');
    const v = (cents / 100).toFixed(2).split('.');
    const withComma = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma).replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };

  const openDrawer = (state) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents && state) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
    } else {
      window.location = window.routes.cart_url;
    }
  };

  const addItems = async (items, sectionsFrom) => {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const state = await res.json();
    if (state.status) throw new Error(state.description || state.message);
    return state;
  };

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const sid = root.dataset.section;
    const section = document.getElementById('shopify-section-' + sid) || document;
    const product = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const form = root.querySelector('form[data-aurea-pdp-form]');
    const idInput = form && form.querySelector('[data-variant-id]');
    const atc = root.querySelector('[data-atc]');

    const currentOptions = () => product.options.map((_, i) => {
      const checked = section.querySelector(`input[name="option${i + 1}"]:checked`);
      return checked ? checked.value : null;
    });
    const updateVariant = () => {
      const opts = currentOptions();
      const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      section.querySelectorAll('[data-sale]').forEach((e) => (e.textContent = money(variant.price)));
      section.querySelectorAll('[data-compare]').forEach((e) => {
        e.textContent = money(variant.compare_at_price || 0);
        e.parentElement.hidden = !(variant.compare_at_price > variant.price);
      });
      section.querySelectorAll('[data-sale-wrap]').forEach((e) => e.classList.toggle('is-sale', variant.compare_at_price > variant.price));
      opts.forEach((o, i) => { const el = section.querySelector(`[data-option-value="${i + 1}"]`); if (el) el.textContent = o; });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media) {
        const m = root.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        if (m) goTo(parseInt(m.dataset.index, 10));
      }
    };
    section.querySelectorAll('[data-variant-picker] input[type=radio]').forEach((r) => r.addEventListener('change', updateVariant));

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!atc) return;
        atc.classList.add('is-loading');
        atc.setAttribute('aria-busy', 'true');
        const items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
        const addon = root.querySelector('[data-addon]');
        if (addon && addon.checked) items.unshift({ id: parseInt(addon.dataset.addon, 10), quantity: 1 });
        try {
          openDrawer(await addItems(items));
        } catch (err) {
          console.error(err);
        } finally {
          atc.classList.remove('is-loading');
          atc.removeAttribute('aria-busy');
        }
      });
    }

    const list = root.querySelector('[data-gallery]');
    const thumbs = root.querySelectorAll('[data-thumbs] .aurea-gallery__thumb');
    const medias = root.querySelectorAll('.aurea-gallery__media');
    const goTo = (i) => {
      if (!list || !medias[i]) return;
      if (getComputedStyle(list).overflowX === 'visible') return;
      list.scrollTo({ left: medias[i].offsetLeft - list.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.index, 10))));
    if (list && thumbs.length) {
      list.addEventListener('scroll', () => {
        const i = Math.round(list.scrollLeft / (medias[0].getBoundingClientRect().width + 4));
        thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      }, { passive: true });
    }

    const lb = section.querySelector('[data-lightbox]');
    if (lb) {
      const img = lb.querySelector('[data-lb-img]');
      let cur = 0;
      const show = (i) => { cur = (i + medias.length) % medias.length; img.src = medias[cur].dataset.full; };
      medias.forEach((m, i) => m.addEventListener('click', () => { if (!m.dataset.full) return; show(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }));
      const close = () => { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
      lb.querySelector('[data-lb-close]').addEventListener('click', close);
      lb.querySelector('[data-lb-prev]').addEventListener('click', () => show(cur - 1));
      lb.querySelector('[data-lb-next]').addEventListener('click', () => show(cur + 1));
      document.addEventListener('keydown', (e) => { if (!lb.classList.contains('is-open')) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(cur - 1); if (e.key === 'ArrowRight') show(cur + 1); });
    }

    const info = root.querySelector('[data-info]');
    const stick = () => { if (!info) return; const h = info.offsetHeight; info.style.top = (h > window.innerHeight ? Math.min(0, window.innerHeight - h) : 20) + 'px'; };
    window.addEventListener('resize', stick); stick();

    const bar = section.querySelector('[data-qa-bar]');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver((en) => {
        const e = en[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
    }

    const xs = root.querySelector('[data-xs]');
    if (xs) {
      const xl = xs.querySelector('[data-xs-list]');
      const prev = xs.querySelector('[data-xs-prev]');
      const next = xs.querySelector('[data-xs-next]');
      const upd = () => {
        prev.setAttribute('aria-disabled', xl.scrollLeft <= 1 ? 'true' : 'false');
        next.setAttribute('aria-disabled', xl.scrollLeft >= xl.scrollWidth - xl.clientWidth - 1 ? 'true' : 'false');
      };
      const url = `${window.routes.product_recommendations_url}?product_id=${xs.dataset.productId}&limit=${xs.dataset.limit}&section_id=aurea-xs-items&intent=related`;
      fetch(url).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelector('[data-xs-items]');
        let src = items && items.children.length ? [...items.children] : null;
        if (!src) {
          const fb = xs.parentElement.querySelector('[data-xs-fallback]');
          src = fb ? [...fb.content.children] : [];
        }
        if (!src.length) { xs.closest('.b-xs').hidden = true; return; }
        src.forEach((c) => xl.appendChild(document.importNode(c, true)));
        upd();
      });
      xl.addEventListener('scroll', upd, { passive: true });
      prev.addEventListener('click', () => xl.scrollBy({ left: -xl.clientWidth, behavior: 'smooth' }));
      next.addEventListener('click', () => xl.scrollBy({ left: xl.clientWidth, behavior: 'smooth' }));
      xl.addEventListener('click', async (e) => {
        const b = e.target.closest('[data-xs-add]');
        if (!b) return;
        b.disabled = true;
        try { openDrawer(await addItems([{ id: parseInt(b.dataset.xsAdd, 10), quantity: 1 }])); } catch (err) { console.error(err); } finally { b.disabled = false; }
      });
    }

    root.querySelectorAll('[data-mc-carousel-section]').forEach((sectionEl) => {
      const carousel = sectionEl.querySelector('.vc-image-carousel');
      if (!carousel || carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      let dragging = false, startX = 0, startScroll = 0, moved = false;
      carousel.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true; moved = false; startX = event.clientX; startScroll = carousel.scrollLeft;
        carousel.setPointerCapture(event.pointerId); carousel.classList.add('is-dragging');
      });
      carousel.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 4) moved = true;
        carousel.scrollLeft = startScroll - distance * 1.5;
      });
      const stop = () => { dragging = false; carousel.classList.remove('is-dragging'); };
      carousel.addEventListener('pointerup', stop);
      carousel.addEventListener('pointercancel', stop);
      carousel.addEventListener('lostpointercapture', stop);
      carousel.addEventListener('click', (event) => { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, true);
      carousel.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        carousel.scrollBy({ left: carousel.clientWidth * (event.key === 'ArrowRight' ? 0.75 : -0.75), behavior: 'smooth' });
      });
    });
  };

  const initAccordion = (d) => {
    if (d.dataset.acc) return;
    d.dataset.acc = '1';
    const summary = d.querySelector('summary');
    const content = d.querySelector('.accordion__content');
    if (!summary || !content) return;
    d.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    if (!d.open) { content.style.opacity = '0'; content.style.transform = 'translateY(-4px)'; }
    let busy = false;
    summary.addEventListener('click', async (e) => {
      e.preventDefault();
      if (busy) return;
      busy = true;
      d.style.overflow = 'hidden';
      d.setAttribute('aria-expanded', d.open ? 'false' : 'true');
      if (!d.open) {
        d.setAttribute('open', '');
        const h = d.animate({ height: [`${summary.clientHeight}px`, `${d.scrollHeight}px`] }, { duration: 250, easing: 'ease' });
        const c = content.animate({ opacity: [0, 1], transform: ['translateY(0)', 'translateY(-4px)'] }, { duration: 150, delay: 130, easing: 'ease', fill: 'backwards' });
        await Promise.all([h.finished, c.finished]);
        content.style.opacity = '1';
        content.style.transform = 'translateY(-4px)';
      } else {
        const from = d.clientHeight;
        const c = content.animate({ opacity: [1, 0] }, { duration: 150, easing: 'ease' });
        const h = d.animate({ height: [`${from}px`, `${summary.clientHeight}px`] }, { duration: 250, easing: 'ease' });
        content.style.opacity = '0';
        d.style.height = `${summary.clientHeight}px`;
        await Promise.all([h.finished, c.finished]);
        d.removeAttribute('open');
      }
      d.style.height = 'auto';
      d.style.overflow = 'visible';
      busy = false;
    });
  };

  const scan = () => {
    document.querySelectorAll('[data-aurea-pdp]').forEach(init);
    document.querySelectorAll('details.b-accordion, details.b-accordion-faq').forEach(initAccordion);
  };
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
